module.exports = __webpack_public_path__ + "img/presencia-internacional.eaf760fa.png";